import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function Hero() {
  return <section className="bg-crema text-bordo pt-16 pb-20 px-4 md:px-8 overflow-hidden" data-id="element-85">
      <div className="max-w-4xl mx-auto text-center" data-id="element-86">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-87">
          <h1 className="text-3xl md:text-5xl font-serif font-bold mb-8 leading-tight" data-id="element-88">
            Soluciona tus comidas de la semana
            <br data-id="element-89" />
            <span className="text-bordo-light" data-id="element-90">con esta guía</span>
          </h1>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="my-12 flex justify-center cursor-pointer" onClick={() => document.getElementById('checkout')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-91">
            <img src="https://cdn.magicpatterns.com/uploads/p84DxRJ8h8jJ4vJCr4drQM/ChatGPT_Image_Apr_30__2026__05_47_03_PM-removebg-preview.png" alt="La Biblia de la Milanesa - Producto completo" className="w-[80%] max-w-2xl h-auto drop-shadow-2xl" data-id="element-92" />
          </motion.div>

          <div className="space-y-4 text-lg md:text-xl mb-12 font-medium text-gray-800" data-id="element-93">
            <p data-id="element-94">Abrís la heladera.</p>
            <p data-id="element-95">Mirás un rato.</p>
            <p data-id="element-96">Pensás qué podés hacer rápido.</p>
            <p data-id="element-97">Y otra vez aparece la misma pregunta de todos los días:</p>
            <p className="font-serif text-2xl text-bordo italic my-6" data-id="element-98">
              "¿Qué cocino hoy?"
            </p>
            <p data-id="element-99">No querés complicarte.</p>
            <p data-id="element-100">No querés pasar una hora cocinando.</p>
            <p data-id="element-101">Entonces aparece la salida de siempre:</p>
            <p className="font-serif text-3xl font-bold text-bordo my-6" data-id="element-102">
              milanesa.
            </p>
            <p className="font-bold mt-8" data-id="element-103">Pero también pasa algo…</p>
            <p data-id="element-104">La hacés siempre igual.</p>
            <p data-id="element-105">Mismo corte. Mismo empanado. Misma guarnición. Mismo sabor.</p>
            <p className="text-xl md:text-2xl font-serif font-bold text-bordo-light mt-6" data-id="element-106">
              Y una comida que podría ser increíble termina siendo apenas "lo de
              siempre".
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="mt-12" data-id="element-107">
          <CTAButton data-id="element-108" />
        </motion.div>
      </div>
    </section>;
}